import {API_AUTHACTION_GOOGLELOGIN, API_AUTHACTION_LOGIN} from "../../const/Api";
import {RestApiMethod} from "../../const/dataEnum";
import {callAPI} from "./callApi";

const login = async (data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_AUTHACTION_LOGIN,
      data,
    });
    return res.data.data;
  } catch (error) {
    console.error('login Error:', error.message);
    return null;
  }
};

const googleLogin = async (credential) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_AUTHACTION_GOOGLELOGIN,
      data: {
        idToken: credential
      }
    });
    return res.data.data;
  } catch (error) {
    console.error('googleLogin Error:', error.message);
    return null;
  }
};

const authActionApi = {
  login,
  googleLogin
}

export default authActionApi;